import { Pipeline, Stage } from 'utils/types';

export const mockPipelineData: Pipeline[] = [
  {
    _id: '551f63c7-e87a-5175-a15a-ba714126514c',
    id: '551f63c7-e87a-5175-a15a-ba714126514c',
    accountId: '81468051-b1df-5e98-8e09-e64af89e1d10',
    deal: 1,
    isPrimary: true,
    name: 'Test Pipeline 1',
    sequence: 1,
  },
  {
    _id: '2640ec73-e896-5b4c-8cab-b6de20a0fc09',
    id: '2640ec73-e896-5b4c-8cab-b6de20a0fc09',
    accountId: '81468051-b1df-5e98-8e09-e64af89e1d10',
    deal: 1,
    isPrimary: true,
    name: 'Test Pipeline 2',
    sequence: 2,
  },
];

export const mockStageData: Stage[] = [
  {
    _id: '84116093-0ecf-56ef-ba13-9cc26b3490ac',
    actions: [],
    deal: 1,
    isPrimary: true,
    name: 'Test Stage',
    pipelineId: '551f63c7-e87a-5175-a15a-ba714126514c',
    sequence: 1,
  },
  {
    _id: '62fe2ed4-ef2f-5e63-bbe6-59b6434e72a4',
    actions: [],
    deal: 1,
    isPrimary: true,
    name: 'Stage 2',
    pipelineId: '551f63c7-e87a-5175-a15a-ba714126514c',
    sequence: 2,
  },
];
